<script>
</script>
<div  id="hero">
<img

  src="./assets/typo-bands-min/clawsofsaurtopianoisefest8.png"
  alt="Orange-blue poster for Claws Of Saurtopia festival 2022"
/></div>
<header>
  <h1 hidden>Claws Of Saurtopia #8 ~ May 27 + 28, 2022</h1>

  <div>
    Hey dear noise heads! After a rather long hiatus, we are happy to be back
    with another edition of the earpiercing, gutwrenching, jurassic <em
      >Claws of Saurtopia</em
    >
    noise festival! Happening
    <em>May 27 and May 28, 2022 at ZXRX Leipzig</em>!<br />
    No presale!<br />
    Just drop by and make sure to bring an official negative antigen test.<br />
    Looking forward to seeing you all again!
  </div>
</header>
<main>
  <div class="timetable-container">
    <div class="date-head">
      <h2>[Friday]<br />May 27, 2022<br />Doors: 20:00</h2>
    </div>
    <div class="slot-container">
      <div>
        <div>21:00</div>
        <a href="https://flennen.bandcamp.com/track/snitsh-pitsh-rosie-coaster">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/snitshpitsh.min.png"
        alt="band logo of snitsh pitsh"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>21:45</div>
        <!--<a href=""></a>-->
      </div>
      <img
        src="./assets/typo-bands-min/icmefur.min.png"
        alt="band logo of icmefur"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>22:15</div>
        <a href="https://cesarpalace.bandcamp.com">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/cesarpalace.min.png"
        alt="band logo of cesarpalace"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>23:00</div>
        <a href="https://youtu.be/ZpbreLDqeTA">YT</a>
      </div>
      <img
        src="./assets/typo-bands-min/genesisvictoria.min.png"
        alt="band logo of genesisvictoria"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>23:45</div>
        <a href="https://donvito.bandcamp.com/">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/donvito.min.png"
        alt="band of logo of don vito"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>24:30</div>
        <a href="https://duflanduflan.bandcamp.com">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/duflanduflan.min.png"
        alt="band logo of duflanduflan"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>25:15</div>
        <!--<a href=""></a>-->
      </div>
      <img
        src="./assets/typo-bands-min/steiner+twodots.min.png"
        alt="band logo of steiner+twodots"
      />
    </div>
  </div>
  <!-- <div class="poster-container">
    <img
      src="./assets/nf8-sieb-frei.jpg"
      alt="orange-blue poster with cyborg dinosaurs for Claws Of Saurtopia festival 2022"
    />
  </div> -->
  <div class="timetable-container">
    <div class="date-head">
      <h2>[Saturday]<br />May 28, 2022<br />Doors: 20:00</h2>
    </div>
    <div class="slot-container">
      <div>
        <div>21:00</div>
        <a href="https://goldendoomrecords.bandcamp.com/album/hell">BC</a>
      </div>
      <img src="./assets/typo-bands-min/rusz.min.png" alt="band logo of rusz" />
    </div>
    <div class="slot-container">
      <div>
        <div>22:00</div>
        <a href="https://soundcloud.com/catarat/c100000000">SC</a>
      </div>
      <img
        src="./assets/typo-bands-min/catarat.min.png"
        alt="band logo of catarat"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>22:45</div>
        <a href="https://crippleclerk.bandcamp.com/">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/eyaltalmor.min.png"
        alt="band logo of eyaltalmor"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>23:30</div>
        <a href="https://kurws.bandcamp.com">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/kurws.min.png"
        alt="band logo of kurws"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>24:15</div>
        <a href="https://and-kal.github.io/livecoding">GH</a>
      </div>
      <img
        src="./assets/typo-bands-min/staxl.min.png"
        alt="band logo of staxl"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>24:45</div>
        <a href="https://yc-cy.bandcamp.com/">BC</a>
      </div>
      <img
        src="./assets/typo-bands-min/yc-cy.min.png"
        alt="band logo of yc-cy"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>25:30</div>
        <a href="https://soundcloud.com/va-les-ka">SC</a>
      </div>
      <img
        src="./assets/typo-bands-min/valeska.min.png"
        alt="band logo of valeska"
      />
    </div>
    <div class="slot-container">
      <div>
        <div>27:00</div>
        <a href="https://soundcloud.com/gleeetch">SC</a>
      </div>
      <img
        src="./assets/typo-bands-min/gleeetch.min.png"
        alt="band logo of gleeetch"
      />
    </div>
  </div>
</main>

<footer>
  <!-- <a href="/impressum.html">🦖 🖱Impressum 🦕</a> -->
  <a href="https://clawsofsaurtopia-blog.tumblr.com">🦖 🖱Archive 🦕</a>
</footer>

<style>

  #hero {
    text-align: center;
  }
  #hero img {
    max-width: 95%;
    margin: 2rem auto;
  }
  header div {
    font-size: 1.25rem;
    background-color: #096cbd;
    padding: 1em;
    color: #ddd;
  }
  main {
    text-align: center;
    max-width: none;
    /* height: auto; */
    /* max-height: 100%; */
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  a {
    background-color: #59ed24;
    color: rgb(87, 9, 189);
    font-size: 1.5rem;
    text-decoration: none;
    border: 3px solid #333;
    padding: 0.25em;
  }

  a:hover {
    transition: background-color 1s;
    background-color: #f55732;
    color: rgb(87, 9, 189);
  }

  em {
    font-weight: 700;
    font-style: italic;
  }

  .timetable-container {
    max-width: 100%;
    /* max-height: 60vh; */
    margin: 2rem auto;
    /* display: grid;
    grid-template-columns: 1fr;
    row-gap: 2em;
    column-gap: 1em; */
    font-size: 2rem;
    font-weight: 700;
    text-align: left;
  }

  .timetable-container * {
    align-self: center;
  }

  .timetable-container .date-head {
    font-size: 1.25rem;
    align-self: baseline;
    width: 100%;
  }
  .timetable-container .date-head h2 {
    text-align: center;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  .timetable-container:first-child .date-head h2 {
  background-color: #5624ed;
    color: #ed47d9;
    border: 18px solid #59ed24;
  }

  .timetable-container:nth-child(2) .date-head h2 {
  background-color: #59ed24;
    color: #c700b0;
    border: 18px solid #5624ed;
  }

  .timetable-container .slot-container {
    display: grid;
    grid-template-columns: 1fr 3fr;
    column-gap: 1em;
    height: 185px;
  }

  .timetable-container:first-child .slot-container:nth-child(2n) {
    background-color: #096cbd;
    color: #f55732;
  }

  .timetable-container:first-child .slot-container:nth-child(2n + 1) {
    background-color: #f55732;
    color: #096cbd;
  }

  .timetable-container:nth-child(2) .slot-container:nth-child(2n) {
    background-color: #f55732;
    color: #096cbd;
  }

  .timetable-container:nth-child(2) .slot-container:nth-child(2n + 1) {
    background-color: #096cbd;
    color: #f55732;
  }

  .timetable-container .slot-container > div {
    text-align: center;
  }

  .timetable-container .slot-container img {
    max-width: 75%;
    max-height: 185px;
  }

  footer {
    margin-top: 2rem;
    text-align: right;
  }

  @media (max-width: 1024px) {
    header {
      padding: 0;
    }
    #hero img {
      position: sticky;
      top: 2px;
      margin: 1rem auto;
      max-width: 100%;
    }
    header div {
      font-size: 1em;
    }
    .timetable-container .date-head {
      font-size: 1.33rem;
    }
    main {
      grid-template-columns: 1fr;
    }
    .timetable-container {
      max-width: 99%;
      justify-items: center;
    }
    footer a {
      font-size: 1em;
    }
  }

  @media (max-width: 640px) {
    .timetable-container .slot-container img {
      max-width: 90%;
    }
  }
</style>
